import React, { useEffect } from 'react'
import { ContainerLaboratory } from './styles'
import { withDashboardLoader } from '~/components/shared'
import { Content, Header } from '~/components/laboratoryMedicalView'
import { LaboratoryHealthProceduresProvider, usePatient } from '~/context'
import { useDocumentTitle, useMaternalInfantViewSettings } from '~/hooks'
import { message } from '~/services'

const LaboratoryMedicalViewPage = (): JSX.Element => {
  useDocumentTitle(message('titles.timeline_laboratory'))
  const { resetPatientTag } = usePatient()
  const { cleanupMaternalInfantViewSettings } = useMaternalInfantViewSettings()

  useEffect(() => {
    resetPatientTag()
    cleanupMaternalInfantViewSettings()
  }, [resetPatientTag])

  return (
    <LaboratoryHealthProceduresProvider>
      <ContainerLaboratory>
        <Header />
        <Content />
      </ContainerLaboratory>
    </LaboratoryHealthProceduresProvider>
  )
}

export const LaboratoryMedicalView = withDashboardLoader(LaboratoryMedicalViewPage)
